export default $(()=>{

    let $country = $('body.section-submittal-manager select#country');
    let $states = $('body.section-submittal-manager label[for=state]');
    let $unitedStates = $states.find('select#state.united-states');
    let $canada = $states.find('select#state.canada');

    $country.on('change', function() {
        switch ($(this).val()) {
            case 'United States':
                $states.children().show();
                $unitedStates.show().prop('disabled', false);
                $canada.hide().prop('disabled', true);
                break;

            case 'Canada':
                $states.children().show();
                $unitedStates.hide().prop('disabled', true);
                $canada.show().prop('disabled', false);
                break;

            case 'Mexico':
                $states.children().hide();
                $unitedStates.prop('disabled', true);
                $canada.prop('disabled', true);
        }
    }).triggerHandler('change');
});